export const appPageTitles = {
  general: "cmFeedback",
  topics: "cmFeedback Topics",
  workflows: "cmFeedback Workflows"
};
